export default __webpack_public_path__ + "static/img/promo-icon-3-active.292ba45.png";